import axios from 'axios';
export var ForgotPassword = function (baseURL, credentials) {
    return axios.post(baseURL + '/reset/forgot-password', credentials, {
        headers: { 'Content-Type': 'application/json' },
    });
};
export var UpdatePassword = function (baseURL, userUUID, headers, credentials) {
    return axios.put(baseURL + '/password/' + userUUID, credentials, {
        headers: {
            Authorization: 'Bearer ' + headers.accessToken,
            'Content-Type': 'application/json',
            'X-View-As': headers.viewAs,
            'X-Client-Group': null,
        },
    });
};
